import { EUserType, ITokenPayload, IUser, IUserCredentialsDTO } from '@zunta/configurations'
import { IBaseStore } from '../types'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import Api from '../../api'

export interface IAuthState {
  errors: Array<String>,
}

export interface IAuthStore extends IBaseStore {
  state: IAuthState
}

@Module({
  name: 'auth',
  namespaced: true
})
export class AuthModule extends VuexModule {
  errors: string[] = [];

  @Mutation
  applyError (errors: string[]) {
    this.errors = errors
  }

  @Action
  async login (credentials: IUserCredentialsDTO) {
    this.applyError([])
    const body: IUserCredentialsDTO & { viewportWidth: number, viewportHeight: number } = {
      ...credentials,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight
    }
    const response = await Api.auth.doLogin(body)
    if (response.user) {
      this.context.commit('user/SET_USER', response.user as IUser, { root: true })
    }
    if (!response.accessToken) {
      const isUnauthorized = (response as { statusCode: number }).statusCode === 401
      isUnauthorized && this.applyError(['Wrong Email or Password'])
      return false
    } else {
      return response
    }
  }

  @Action
  setToken (token: any) {
    Api.setToken(token, true)
  }

  @Action
  async forgotPassword (email: string) {
    return Api.auth.forgotPassword(email)
  }

  @Action
  async checkPccLogin (credentials: { username: string, password: string }): Promise<boolean> {
    return Api.auth.checkPccLogin(credentials.username, credentials.password)
  }

  @Action
  async refreshToken () {
    return Api.refreshToken()
  }

  @Action
  async validateCredentials (credentials: IUserCredentialsDTO) {
    this.applyError([])
    const response = await Api.auth.validateCredentials(credentials)
    if (!response.accessToken) {
      const isUnauthorized = (response as { statusCode: number }).statusCode === 401
      isUnauthorized && this.applyError(['Wrong Email or Password'])
      return false
    } else {
      return response.accessToken
    }
  }

  @Action
  async getIsValidUser (userData: ITokenPayload): Promise<boolean> {
    if (userData.type === EUserType.ZUNTA) return true
    return !!(userData.chain || (userData.residents && userData.residents.length))
  }
}
